export default __webpack_public_path__ + "static/media/pin-png-39475.f259e709.png";